import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Alert,
    CardBody,
    Button,
    Label,
    Input,
    FormFeedback,
    Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import UserService from "Api/Services/UserService";
import { useNavigate } from "react-router-dom";
import DrugService from "Api/Services/DrugService";
import Spinners from "components/Common/Spinner";

const DrugAdd = () => {

    //meta title
    document.title = "Drug Add | infuseone - Admin";
    const [status, setStatus] = useState(true);
    const navigate = useNavigate();
    const handleStatusChange = () => setStatus(!status);
    const [title, setTitle] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errorimage, setErrorimage] = useState(false);

    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setPreviewImage(file);
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setPreviewImage(reader.result);
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };
    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const fileType = file.type;
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

            if (validImageTypes.includes(fileType)) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviewImage(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                setErrorimage('Please upload a valid image.');
                return;
                // alert('Please upload a valid image file.');
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userData = {
            name: e.target.title.value,
            image: previewImage,
            form_iframe: e.target.form_iframe.value,
            status: status && status == 1 ? '1' : '0',
        };
        // setLoading(true);
        try {
            const response = await DrugService.AddDrug(userData).json();
            if (response.status) {
                setTimeout(() => {
                    setError('');
                    setSuccess(response.message);
                    setErrorimage('');
                    // setLoading(false);
                });
                navigate('/drug-list')
            } else {

                setError(response.errors);
                return;
            }
        } catch (error) {
            setError('something went wrong');
            return;
        }
    };


    const handletitleChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setTitle(newValue);
        }
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Drug Add" />
                    {isLoading ? <Spinners setLoading={setLoading} /> :
                        <Card className="commonboxform">
                            <CardBody>
                                {success && (
                                    <Alert color="success" style={{ marginTop: "13px" }}>
                                        {success}
                                    </Alert>
                                )}


                                {/* <h4 className="card-title mb-4">Drug Add</h4> */}
                                <Form className="form-horizontal" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <div className="mb-3">
                                            <Label className="form-label">Title <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name='title'
                                                value={title}
                                                onChange={handletitleChange}
                                            />
                                            {error.name && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>
                                                    {error.name[0]}
                                                </FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Image <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            {previewImage &&
                                                <div className="mb-3 text-left">
                                                    <img
                                                        src={previewImage}
                                                        alt="Profile Preview"
                                                        className="img-fluid"
                                                        style={{ width: '100px', height: '60px', objectFit: 'cover' }}
                                                    />
                                                </div>}
                                            <Input
                                                type="file"
                                                className="form-control"
                                                id="image"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            {error.image && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.image}</FormFeedback>
                                            )}
                                            {errorimage && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{errorimage}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">Iframe Form <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="form_iframe"
                                                name='form_iframe'
                                            />
                                            {error.form_iframe && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.form_iframe}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">Status</Label>
                                            <div className="form-check form-switch form-switch-lg mb-3" >
                                                <Input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizelg"
                                                    name='status'
                                                    defaultChecked={status}
                                                    onChange={handleStatusChange}
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    htmlFor="customSwitchsizelg"
                                                >
                                                    {status ? 'Active' : 'Inactive'}
                                                </Label>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="text-left mt-4">
                                        <Button type="submit" color="secondary">
                                            Submit
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    }
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DrugAdd;
